export const home = {
  greeting: {
    morning: "Good morning, {{name}}",
    afternoon: "Good afternoon, {{name}}",
    evening: "Good evening, {{name}}",
    summary: "Here's what's happening across {{scope}} today.",
    allAccounts: "all your accounts",
  },
  quick: {
    compose: "Create post",
    inbox: "Open inbox",
    approvals: "Review approvals",
    reviewApprovals: "Review approvals ({{n}})",
    assistant: "Ask the assistant",
  },
  kpi: {
    title: "Last 28 days",
    reach: "Reach",
    reachHint: "Unique accounts that saw your content",
    views: "Views",
    viewsHint: "Times your content was played or displayed",
    engagement: "Engagement",
    engagementHint: "Likes, comments, shares and saves",
    engagementRate: "{{rate}} of reach",
    followers: "Followers",
    followersHint: "Total followers now",
    vs: "vs previous 28 days",
    noPrevious: "No earlier data yet",
    trend: "{{metric}} trend, last 28 days",
  },
  sentiment: {
    title: "Comment sentiment",
    description: "How people feel in your comments (28 days)",
    total: "comments",
    empty: "No comments in this period yet",
  },
  automation: {
    title: "Automation impact",
    description: "What Malfak handled for you (28 days)",
    handled: "Handled",
    autoReplied: "Auto-replied",
    hidden: "Hidden",
    saved: "Time saved",
    manage: "Manage rules",
  },
  approvals: {
    title: "Waiting for approval",
    description: "AI drafts your rules want you to check",
    empty: "Nothing waiting",
    emptyHint: "Drafts from approve-first rules land here.",
    approved: "Approved and sent",
    rejected: "Rejected",
    viewAll: "All approvals",
    draft: "Draft",
    noDraft: "No text: action only",
    kinds: {
      reply_public: "Public reply",
      reply_private: "Private reply",
      send_message: "Direct message",
      hide: "Hide comment",
      delete: "Delete comment",
      bulk: "Bulk action",
    },
  },
  activity: {
    title: "Live activity",
    description: "New comments and messages as they arrive",
    empty: "Quiet for now",
    emptyHint: "New comments and DMs will stream in here.",
    commented: "commented",
    messaged: "sent a message",
    voiceNote: "Voice note",
    attachment: "Attachment",
    openInbox: "Open inbox",
    newBadge: "New",
  },
  bestTime: {
    title: "Best time to post",
    description: "When your followers are most active",
    top: "Top slot",
    schedule: "Plan a post",
  },
  upcoming: {
    title: "Coming up",
    description: "Scheduled posts",
    empty: "Nothing scheduled",
    emptyHint: "Plan your next post and Malfak publishes it on time.",
    calendar: "Open calendar",
  },
  guide: {
    title: "Getting started",
    progress: "{{done}} of {{total}} done",
    hide: "Hide this guide",
    show: "Show the getting started guide",
    done: "done",
    todo: "to do",
    importing: "Importing your recent posts and comments from @{{user}}…",
    inboxReady: "Your inbox is ready",
    steps: {
      connect: "Connect Instagram",
      import: "Import your posts and comments",
      reply: "Reply to a comment with AI",
      rule: "Turn on your first rule",
      invite: "Invite a teammate",
      post: "Plan your next post",
    },
  },
  attention: {
    reconnect_one: "@{{user}} needs to be reconnected before Malfak can read or reply.",
    reconnect_other: "{{count}} accounts need to be reconnected before Malfak can read or reply.",
    reconnectAction: "Reconnect",
  },
  crisis: {
    title: "Negative comments are spiking",
    body_one: "{{count}} negative comment in the last 24 hours, about {{times}}× your usual daily level.",
    body_other: "{{count}} negative comments in the last 24 hours, about {{times}}× your usual daily level.",
    action: "Review now",
    dismiss: "Dismiss",
  },
  error: "Couldn't load your dashboard",
};
